import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    endpoint: { type: String, default: "/anuncios/activo" }
  }

  connect() {
    this.shown = false
    this.fetchCampaign()
  }

  async fetchCampaign() {
    try {
      const res = await fetch(this.endpointValue, {
        headers: { "Accept": "application/json" }
      })
      if (!res.ok) return
      const data = await res.json()
      if (!data || !data.id) return

      const storageKey = `almagro:anuncio:${data.id}`
      const lastShown = localStorage.getItem(storageKey)
      const now = Date.now()
      const frecuenciaMs = (data.frecuencia_dias || 7) * 24 * 60 * 60 * 1000

      if (lastShown && (now - parseInt(lastShown)) < frecuenciaMs) return

      const delay = (data.delay_segundos || 3) * 1000
      setTimeout(() => this.show(data), delay)
    } catch (e) {
      console.warn("Anuncio fetch error:", e)
    }
  }

  show(data) {
    if (this.shown) return
    this.shown = true

    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-[300] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 opacity-0 transition-opacity duration-300"
    overlay.dataset.anuncioOverlay = true

    const modal = document.createElement("div")
    modal.className = "relative w-full max-w-[700px] max-h-[90vh] rounded-2xl overflow-hidden bg-[#003366] shadow-2xl transform scale-90 opacity-0 transition-all duration-300"

    const closeBtn = document.createElement("button")
    closeBtn.type = "button"
    closeBtn.setAttribute("aria-label", "Cerrar")
    closeBtn.className = "absolute top-3 right-3 z-10 w-10 h-10 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition"
    closeBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5"><path d="M18 6L6 18M6 6l12 12"/></svg>'
    closeBtn.addEventListener("click", () => this.close(overlay))

    const img = document.createElement("img")
    img.src = data.imagen_url
    img.alt = data.titulo
    img.className = "w-full h-auto max-h-[90vh] object-contain cursor-pointer"
    img.loading = "lazy"

    const link = document.createElement("a")
    link.href = data.url_destino
    link.target = "_blank"
    link.rel = "noopener"
    link.className = "block"
    link.appendChild(img)
    link.addEventListener("click", () => this.close(overlay))

    modal.appendChild(closeBtn)
    modal.appendChild(link)
    overlay.appendChild(modal)
    document.body.appendChild(overlay)
    document.body.style.overflow = "hidden"

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) this.close(overlay)
    })

    document.addEventListener("keydown", this.escHandler = (e) => {
      if (e.key === "Escape") this.close(overlay)
    })

    requestAnimationFrame(() => {
      overlay.classList.remove("opacity-0")
      modal.classList.remove("scale-90", "opacity-0")
    })

    const storageKey = `almagro:anuncio:${data.id}`
    localStorage.setItem(storageKey, String(Date.now()))
  }

  close(overlay) {
    if (!overlay) return
    const modal = overlay.querySelector("[data-anuncio-overlay] > div")
    overlay.classList.add("opacity-0")
    if (modal) modal.classList.add("scale-90", "opacity-0")
    setTimeout(() => {
      overlay.remove()
      document.body.style.overflow = ""
    }, 300)
    document.removeEventListener("keydown", this.escHandler)
  }
}
